<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";
import moment from "moment";
import {dataUpdate} from "@/utils/common";

export default defineComponent({
  name: "MinistryExecutionForm",
  data() {
    return {
      loading: false,
      form: {
        ministry_id: null,
        year: moment(Date.now()).format("YYYY"),
        quarter: null,
        plan: null,
        executed: null,
        difference: null,
        percent: null
      },
      ministries: [],
      ministriesTemp: [],
      selectedMinistry: [],
      parentLoading: false,
      quarters: [
        {value: 1},
        {value: 2},
        {value: 3},
        {value: 4}
      ],
      rules: {
        ministry_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        year: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        quarter: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        plan: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        executed: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        difference: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        percent: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  methods: {
    getMinistries() {
      this.loading = true;
      this.$http.get(`api/v1/ministries`, {
        params: {
          limit: 10000,
          offset: 0
        }
      }).then(({data}) => {
        this.ministries = data.data;
        this.ministriesTemp = data.data.map(ministry => {
          return {
            value: ministry.id,
            label: ministry.title,
          }
        })
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
    getFundById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/ministries-execution/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            this.form.year = data.year.toString()
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.year = Number(this.form.year)
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/ministries-execution/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/ministries-execution", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    },
    onChange(val) {
      if (val.length !== 0) {
        this.parentLoading = true;
        this.form.ministry_id = this.selectedMinistry[this.selectedMinistry.length - 1]
        this.$http.get(`api/v1/ministries`, {
          params: {
            parent_id: this.selectedMinistry[this.selectedMinistry.length - 1],
            limit: 10000,
            offset: 0
          }
        })
            .then(({data}) => {
              if (data.data.length > 0) {
                this.ministriesTemp = dataUpdate(
                    this.selectedMinistry[this.selectedMinistry.length - 1],
                    this.ministriesTemp,
                    data.data
                );
              }
            })
            .finally(() => {
              this.parentLoading = false;
            });
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getFundById()
    }
    this.getMinistries()
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Vazirlikni tanlang" prop="ministry_id">
                <el-cascader
                    v-loading="parentLoading"
                    element-loading-spinner="el-icon-loading"
                    style="width: 100%"
                    v-model="selectedMinistry"
                    :options="ministriesTemp"
                    :props="{ checkStrictly: true }"
                    @change="onChange"
                    :show-all-levels="false"
                    clearable
                    popper-class="popper-cls"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Yilni tanlang" prop="year">
                <el-date-picker
                    size="large"
                    style="width: 100%"
                    v-model="form.year"
                    type="year"
                    format="YYYY"
                    value-format="YYYY"
                    placeholder="Yilni tanlang"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Chorakni tanlang" prop="quarter">
                <el-select class="form-input" v-model="form.quarter" size="large"
                           style="margin-right: 10px;width: 100%"
                           placeholder="Chorakni tanlang">
                  <el-option v-for="item in quarters"
                             :value="item.value"
                             :label="item.value"
                             :key="item.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Reja" prop="plan">
                <el-input size="large" v-model.number="form.plan" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Bajarilgan" prop="executed">
                <el-input size="large" v-model.number="form.executed" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Farq" prop="difference">
                <el-input size="large" v-model.number="form.difference" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Foiz" prop="percent">
                <el-input size="large" v-model.number="form.percent" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button size="large" class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button size="large" class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
</style>
